export function captureException(exc) {
  console.log('[Exception]', exc);
}

export function captureBreadcrumb(breadcrumb) {}
